var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"width-24 height-24 muted--text",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M7,10L12,15L17,10H7Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }